import { Badge } from "@/components/ui/badge";
import { CheckCircle, Clock, PauseCircle, MailOpen } from "lucide-react";
import { organization_user_status } from "@/models/organization-user.model";

const statusMap = {
  [organization_user_status.active]: {
    label: "Active",
    icon: <CheckCircle className="w-3 h-3 mr-1.5" />,
    color: "bg-green-100 text-green-700",
  },
  [organization_user_status.invited]: {
    label: "Invited",
    icon: <MailOpen className="w-3 h-3 mr-1.5" />,
    color: "bg-blue-100 text-blue-700",
  },
  [organization_user_status.pending]: {
    label: "Pending Approval",
    icon: <Clock className="w-3 h-3 mr-1.5" />,
    color: "bg-yellow-100 text-yellow-800",
  },
  [organization_user_status.suspended]: {
    label: "Suspended",
    icon: <PauseCircle className="w-3 h-3 mr-1.5" />,
    color: "bg-red-100 text-red-700",
  },
};

export default function StatusBadge({ status }: { status: organization_user_status }) {
  const item = statusMap[status];

  if (!item) return <Badge variant="outline">{status}</Badge>;

  return (
    <span
      className={`inline-flex items-center text-xs font-medium px-2 py-1 rounded-sm w-fit min-w-40 justify-center ${item.color}`}
    >
      {item.icon}
      {item.label}
    </span>
  );
}
